export default {"src":"/_next/static/media/buyer-finance.7f1d8780.svg","height":38,"width":39};